import { CheckOutVisitor } from "./CheckOutVisitor";
import { useState, useEffect } from "react";
import instance from "../../Interceptor/api_instance";
import { CheckOutIcon } from "../../Media/Icons";
import { Dots } from "../../Components/LoadingAnimations/LoadingAnimations";
import { useTranslation } from "react-i18next";

export const CheckOutVisitorList = ({ onClose }) => {
  const { t } = useTranslation();
  const [visitors, setVisitors] = useState([]);
  const [form, setForm] = useState(false);
  const [selectedVisitor, selectVisitor] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const response = await instance.get("assets/get-visitors");
      if (response !== undefined) {
        setVisitors(response.data);
        setIsLoading(false);
      }
    })();
  }, []);

  const handleClose = () => {
    selectVisitor(null);
  };

  const visitorOut = (visitor) => {
    setForm(true);
    selectVisitor(visitor);
  };

  const confirm = async () => {
    setIsConfirmLoading(true);
    const data = {
      first_name: selectedVisitor.visitor.first_name,
      last_name: selectedVisitor.visitor.last_name,
      id: selectedVisitor.visitor.id,
    };
    const response = await instance.post("assets/check-out-visitor/", data);
    if (response.status === 200) {
      setIsConfirmLoading(false);
      setForm(false);
    }
  };
  return (
    <>
      {selectedVisitor && (
        <div>
          <CheckOutVisitor
            onClose={handleClose}
            confirm={confirm}
            visitor={selectedVisitor}
            loading={isConfirmLoading}
          />
        </div>
      )}{" "}
      {!selectedVisitor && (
        <div className="white-cont">
          <h2 className="global-h2 light-black">
            {t("forms.type.visitor.header-out")}
          </h2>
          <h4 className="global-h4 gray bottom-space">
            {t("forms.type.visitor.sub-header")}
          </h4>
          <div
            style={{ display: "flex", gap: "16px", minHeight: "350px" }}
            className="recent-activity"
          >
            {isLoading ? (
              <Dots />
            ) : visitors !== undefined ? (
              <>
                {/* List for "Drivers" */}
                <div className="drivers-list">
                  <h4 className="global-h4">
                    {t("graphics-cont.current-drivers")}
                  </h4>
                  {visitors
                    .filter((visitor) => visitor.visitor.category === "Driver")
                    .map((driver, index) => (
                      <div key={index} className="activity-item">
                        <span className="global-h5 gray">
                          {driver.visitor.first_name} {driver.visitor.last_name}
                        </span>
                        <div onClick={() => visitorOut(driver)}>
                          <CheckOutIcon color="#FF6E6E" />
                        </div>
                      </div>
                    ))}
                </div>

                {/* List for non-"Drivers" */}
                <div className="non-drivers-list">
                  <h4 className="global-h4">
                    {t("graphics-cont.current-visitors")}
                  </h4>
                  {visitors
                    .filter((visitor) => visitor.visitor.category !== "Driver")
                    .map((visitor, index) => (
                      <div key={index} className="activity-item">
                        <span className="global-h5 gray">
                          {visitor.visitor.first_name}{" "}
                          {visitor.visitor.last_name}
                        </span>
                        <div onClick={() => visitorOut(visitor)}>
                          <CheckOutIcon color="#FF6E6E" />
                        </div>
                      </div>
                    ))}
                </div>
              </>
            ) : null}
          </div>

          <br />
          <div className="full-cont">
            <button onClick={onClose} className="cancel-btn">
              {t("buttons.cancel")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};
